const translations = {
  es: {
    strengthText: 'Seguridad',
    strengthLevels: {
      veryWeak: 'Muy débil',
      weak: 'Débil',
      medium: 'Regular',
      strong: 'Fuerte',
      veryStrong: 'Muy fuerte'
    },
    requirements: {
      length: 'Mínimo 8 caracteres',
      uppercase: 'Al menos una mayúscula',
      lowercase: 'Al menos una minúscula',
      number: 'Al menos un número',
      special: 'Al menos un carácter especial (!@#$%^&*)',
      notCommon: 'No contiene palabras o patrones comunes',
      match: 'Las contraseñas coinciden'
    },
    warnings: {
      'Straight rows of keys are easy to guess': 'Las filas rectas de teclas son fáciles de adivinar',
      'Short keyboard patterns are easy to guess': 'Los patrones cortos de teclado son fáciles de adivinar',
      'Sequences like abc or 6543 are easy to guess': 'Secuencias como abc o 6543 son fáciles de adivinar',
      'Recent years are easy to guess': 'Los años recientes son fáciles de adivinar',
      'Dates are often easy to guess': 'Las fechas suelen ser fáciles de adivinar',
      'This is a top-10 common password': 'Esta es una de las 10 contraseñas más comunes',
      'This is a top-100 common password': 'Esta es una de las 100 contraseñas más comunes',
      'This is a very common password': 'Esta es una contraseña muy común',
      'This is similar to a commonly used password': 'Esto es similar a una contraseña comúnmente utilizada',
      'A word by itself is easy to guess': 'Una palabra por sí sola es fácil de adivinar',
      'Names and surnames by themselves are easy to guess': 'Los nombres y apellidos por sí solos son fáciles de adivinar',
      'Common names and surnames are easy to guess': 'Los nombres y apellidos comunes son fáciles de adivinar',
      'Repeats like "aaa" are easy to guess': 'Repeticiones como "aaa" son fáciles de adivinar',
      'Repeats like "abcabcabc" are only slightly harder to guess than "abc"': 'Repeticiones como "abcabcabc" son solo un poco más difíciles de adivinar que "abc"',
      'Added a single number to the end of a word': 'Añadir un solo número al final de una palabra no es seguro',
      'Added a single symbol to the end of a word': 'Añadir un solo símbolo al final de una palabra no es seguro'
    }
  },
  en: {
    strengthText: 'Security',
    strengthLevels: {
      veryWeak: 'Very weak',
      weak: 'Weak',
      medium: 'Medium',
      strong: 'Strong',
      veryStrong: 'Very strong'
    },
    requirements: {
      length: 'Minimum 8 characters',
      uppercase: 'At least one uppercase letter',
      lowercase: 'At least one lowercase letter',
      number: 'At least one number',
      special: 'At least one special character (!@#$%^&*)',
      notCommon: 'Does not contain common words or patterns',
      match: 'Passwords match'
    },
    warnings: {
      // Los warnings en inglés ya vienen directamente de zxcvbn
      // Solo necesitamos mantener este objeto para uniformidad
    }
  }
}

export default translations
